import React, { useState, useLayoutEffect } from "react";
import FutureSkinOne from "./SUK/index";
import FutureSkinTwo from "./Default";
import FutureSkinThree from "./MandG/index";
import { custom1, custom2, custom4 } from "../../../Utils/static-strings";
const FutureMain = (props) => {
  const [skin, setSkin] = useState(null);

  useLayoutEffect(() => {
    if (props.skin) {
      setSkin(props.skin);
    }
  }, []);

  const FutureSkinSwitch = () => {
    switch (sessionStorage.getItem("skinName")) {
      case custom1:
        return <FutureSkinOne {...props} />;
      case custom2:
      case custom4:
        return <FutureSkinThree {...props} />;
      default:
        return <FutureSkinTwo {...props} />;
    }
  };

  return <React.Fragment>{skin !== null && FutureSkinSwitch()}</React.Fragment>;
};

export default FutureMain;
